import React from 'react';
import { useMedia } from 'react-use';

import { media } from '@savgroup-front-common/constants';
import { SUPPORTED_COMPONENTS } from '@savgroup-front-common/types';

import { Link } from '../link';
import { SellerLogo } from '../Logo/SellerLogo/SellerLogo';

import { $LogoContainer } from './DisplayLogo.styles';
import messages from './messages';

interface LogoProps {
  sellerId: string;
  clientId: string;
  href: string;
  isExternal?: boolean;
}

const DisplayLogo: React.FC<LogoProps> = ({
  sellerId,
  clientId,
  isExternal = false,
  href,
}) => {
  const isMobileView = useMedia(media.maxWidth.xs);

  if (isMobileView) {
    return (
      <Link
        ariaLabel={messages.goToHomePage}
        href={href}
        isExternal={isExternal}
        dataTestId="headerlogo-image"
      >
        <$LogoContainer
          componentThemeName={SUPPORTED_COMPONENTS.LOGO}
          $isMobileView={isMobileView}
        >
          <SellerLogo sellerId={sellerId} clientId={clientId} />
        </$LogoContainer>
      </Link>
    );
  }

  return (
    <Link
      ariaLabel={messages.goToHomePage}
      href={href}
      isExternal={isExternal}
      dataTestId="headerlogo-image"
    >
      <$LogoContainer componentThemeName={SUPPORTED_COMPONENTS.LOGO}>
        <SellerLogo sellerId={sellerId} clientId={clientId} />
      </$LogoContainer>
    </Link>
  );
};

export default DisplayLogo;
